import { Grid } from "@mui/material";

import NWONBackgroundLetter from "../../01-atoms/NWONBackgroundLetter/NWONBackgroundLetter";
import {
  LetterName,
  LetterPosition,
} from "../../01-atoms/NWONBackgroundLetter/NWONBackgroundLetterInterfaces";
import NWONTextWithImages from "../../02-molecules/NWONTextWithImages/NWONTextWithImages";
import { MediaPosition } from "../../02-molecules/NWONTextWithImages/NWONTextWithImagesInterfaces";
import NWONSection from "../NWONSection/NWONSection";
import { NWONProjectStepsSectionProps } from "./NWONProjectStepsSectionInterfaces";
import { useNWONProjectStepsSectionStyles } from "./NWONProjectStepsSectionStyles";

const NWONProjectStepsSection = (
  props: NWONProjectStepsSectionProps
): JSX.Element => {
  const { classes } = useNWONProjectStepsSectionStyles();

  return (
    <NWONSection>
      <NWONBackgroundLetter
        letter={LetterName.O}
        position={LetterPosition.Left}
      />

      <Grid container={true} className={classes.stepsWrapper}>
        {props.steps.map((step, index) => (
          <NWONTextWithImages
            key={`step-${step.title}`}
            title={step.title}
            description={step.description}
            illustration={step.image}
            mediaPosition={
              index % 2 === 0 ? MediaPosition.Left : MediaPosition.Right
            }
          />
        ))}
      </Grid>
    </NWONSection>
  );
};

export default NWONProjectStepsSection;
